"use strict";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _shared = require("@widget-editor/shared");

var _colorInput = _interopRequireDefault(require("../../styles-common/color-input"));

var _helpers = require("./helpers");

var _style = require("./style");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var ColorSchemes = function ColorSchemes(_ref) {
  var schemes = _ref.schemes,
      scheme = _ref.scheme,
      widgetScheme = _ref.widgetScheme,
      setSelectedScheme = _ref.setSelectedScheme,
      updateScheme = _ref.updateScheme,
      setSchemes = _ref.setSchemes,
      patchConfiguration = _ref.patchConfiguration;
  var schemesContainCustomScheme = (0, _react.useMemo)(function () {
    return (0, _helpers.containsCustomScheme)(schemes);
  }, [schemes]);
  var isCustomScheme = (0, _react.useMemo)(function () {
    return (0, _helpers.isSchemeCustom)(scheme, schemes);
  }, [schemes, scheme]);
  var isWidgetSchemeCustom = (0, _react.useMemo)(function () {
    return (0, _helpers.isSchemeCustom)(widgetScheme, schemes);
  }, [schemes, widgetScheme]);
  var availableSchemes = (0, _react.useMemo)(function () {
    var schemesWithIds = schemes.map(function (s) {
      return _objectSpread({}, s, {
        id: s.name,
        name: s.name === 'user-custom' ? 'Custom' : s.name
      });
    });

    if (isCustomScheme && !schemesContainCustomScheme) {
      return [].concat(_toConsumableArray(schemesWithIds), [_objectSpread({}, scheme, {
        id: scheme.name,
        name: "Custom"
      })]);
    } else if (isWidgetSchemeCustom && !schemesContainCustomScheme) {
      return [].concat(_toConsumableArray(schemesWithIds), [_objectSpread({}, widgetScheme, {
        id: widgetScheme.name,
        name: "Custom"
      })]);
    }

    return schemesWithIds;
  }, [schemes, scheme, widgetScheme, schemesContainCustomScheme, isCustomScheme, isWidgetSchemeCustom]);
  var onChangeColor = (0, _react.useCallback)(function (index, value) {
    var newColorRange = _toConsumableArray(scheme.category);

    newColorRange.splice(index, 1, value);

    var newScheme = _objectSpread({}, scheme, {
      mainColor: newColorRange[0],
      category: newColorRange
    });

    updateScheme(newScheme);
    patchConfiguration();
  }, [patchConfiguration, scheme, updateScheme]);
  var onCreateCustomScheme = (0, _react.useCallback)(function () {
    setSchemes([].concat(_toConsumableArray(schemes), [_objectSpread({}, scheme, {
      name: 'user-custom'
    })]));
    setSelectedScheme('user-custom');
    patchConfiguration();
  }, [setSchemes, schemes, scheme, setSelectedScheme, patchConfiguration]);
  var onSelectScheme = (0, _react.useCallback)(function (selectedScheme) {
    var isCustom = (0, _helpers.isSchemeCustom)(selectedScheme, schemes);
    setSelectedScheme(isCustom && !schemesContainCustomScheme ? null : selectedScheme.id);
    patchConfiguration();
  }, [schemes, schemesContainCustomScheme, setSelectedScheme, patchConfiguration]);
  return _react["default"].createElement(_style.StyledSchemesContainer, null, !isCustomScheme && !schemesContainCustomScheme && !isWidgetSchemeCustom && _react["default"].createElement(_style.StyledCustomSchemeButtonWrapper, null, _react["default"].createElement(_shared.Button, {
    size: "small",
    onClick: onCreateCustomScheme
  }, "Create custom scheme")), _react["default"].createElement(_style.StyledSchemesCardWrapper, null, availableSchemes.map(function (availableScheme) {
    return _react["default"].createElement(_style.StyledSchemesCard, {
      key: availableScheme.id
    }, _react["default"].createElement(_style.StyledCardBox, {
      active: scheme.name === availableScheme.id,
      onClick: function onClick() {
        return onSelectScheme(availableScheme);
      }
    }, _react["default"].createElement(_style.StyledSchemeInfo, null, _react["default"].createElement(_style.StyledSchemeName, null, availableScheme.name), _react["default"].createElement(_style.StyledSchemeColors, null, _react["default"].createElement("div", {
      style: {
        flexBasis: "100%",
        background: availableScheme.mainColor
      }
    }), _react["default"].createElement("div", {
      style: {
        flexBasis: "100%",
        display: "flex"
      }
    }, (availableScheme.category || []).map(function (color, index) {
      return _react["default"].createElement("div", {
        key: index,
        style: {
          flexBasis: "".concat(100 / availableScheme.category.length, "%"),
          background: color
        }
      });
    }))))));
  })), isCustomScheme && _react["default"].createElement(_style.StyledCustomSchemeWrapper, null, _react["default"].createElement("legend", null, "Customize scheme"), _react["default"].createElement("div", {
    className: "container"
  }, scheme.category.map(function (color, index) {
    return _react["default"].createElement(_colorInput["default"], {
      key: index,
      pickerLabel: "Color ".concat(index + 1),
      inputLabel: "Hexadecimal color ".concat(index + 1),
      value: color,
      onChange: function onChange(value) {
        return onChangeColor(index, value);
      }
    });
  }))));
};

ColorSchemes.propTypes = {
  schemes: _propTypes["default"].arrayOf(_propTypes["default"].object).isRequired,
  scheme: _propTypes["default"].object.isRequired,
  widgetScheme: _propTypes["default"].object,
  setSelectedScheme: _propTypes["default"].func.isRequired,
  updateScheme: _propTypes["default"].func.isRequired,
  setSchemes: _propTypes["default"].func.isRequired,
  patchConfiguration: _propTypes["default"].func.isRequired
};
ColorSchemes.defaultProps = {
  widgetScheme: null
};
var _default = ColorSchemes;
exports["default"] = _default;